import { Injectable } from '@angular/core';
import {
  AbstractGraphqlRequest,
  GraphqlRequestType,
  ItemNotFound,
} from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { PostCategoryModel } from '@app/src/app/modules/post/classes/category/model/post.category.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class PostCategoryRequestQuery extends AbstractGraphqlRequest<
  PostCategoryModel | ItemNotFound
> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query findOnePostCategory(
        $id: GqlEntityIdType!
        $payload: PostCategoryRequestPayloadInput
      ) {
        findOnePostCategory(id: $id, payload: $payload) {
          id
          cover {
            id
            name
            originalName
            extension
            active
            title
            description
            directory
            directories
            chunkEnd
            chunkStart
            frontUrls

            mimetype
            temp
            createdAt
            updatedAt
            createdBy
            updatedBy
          }
          slug
          title
          description
          active
          createdAt
          updatedAt
          deletedAt
          createdBy
          updatedBy
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    let item = data.findOnePostCategory;

    if (item) {
      return new PostCategoryModel(item);
    }

    return new ItemNotFound();
  }
}
